import { Link } from "@tanstack/react-router";
import { CheckList, MarketingPage, StartFreeButton } from "./marketing-kit";

/**
 * Shown to signed-out visitors on routes that read personal data. It returns a
 * normal 200 page with real, crawlable copy instead of a login wall.
 */
export function GuestFeatureScreen({
  eyebrow,
  title,
  description,
  bullets,
  ctaLabel = "Create your free account",
  explore,
}: {
  eyebrow: string;
  title: string;
  description: string;
  bullets: string[];
  ctaLabel?: string;
  explore?: { to: string; label: string }[];
}) {
  return (
    <MarketingPage>
      <p className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
        {eyebrow}
      </p>
      <h1 className="mt-2 text-3xl font-extrabold tracking-tight sm:text-4xl">{title}</h1>
      <p className="mt-4 max-w-2xl text-[15px] leading-relaxed text-muted-foreground">{description}</p>

      <div className="glass mt-7 max-w-2xl rounded-3xl border border-hairline p-6">
        <h2 className="text-[16px] font-bold tracking-tight">What you get once you sign up</h2>
        <div className="mt-4">
          <CheckList items={bullets} />
        </div>
        <StartFreeButton className="mt-6 w-full" label={ctaLabel} />
        <p className="mt-3 text-center text-xs text-muted-foreground">
          Free forever plan. No card required.
        </p>
      </div>

      {explore?.length ? (
        <div className="mt-8">
          <h2 className="text-sm font-semibold">Browse without an account</h2>
          <div className="mt-3 flex flex-wrap gap-2.5">
            {explore.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="glass inline-flex items-center rounded-full border border-hairline px-4 py-2 text-xs font-semibold transition-transform active:scale-95"
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      ) : null}
    </MarketingPage>
  );
}
